export const APP_POSSIBLE_ERROR_MESSAGES = {
  EXPIRED_SESSION: 'Invalid or expired session',
}
